document.addEventListener("DOMContentLoaded", function () {
    const countdownElement = document.getElementById("mg-countdown-timer");

    if (!countdownElement) return;

  
    const targetDate = new Date("April 30, 2026 23:59:59").getTime();

    function updateCountdown() {
        const now = new Date().getTime();
        const distance = targetDate - now;

        if (distance < 0) {
            countdownElement.innerHTML = "Registration Closed";
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((distance / (1000 * 60)) % 60);
        const seconds = Math.floor((distance / 1000) % 60);

        countdownElement.innerHTML = `
    <div class="countdown-wrapper">
        <div class="countdown-title">COUNTDOWN TO MANDATORY GRANTS SUBMISSION DEADLINE</div>
        <div class="countdown-boxes">
            <div class="countdown-box">
                <div class="count-number">${days}</div>
                <div class="count-label">DAYS</div>
            </div>
            <div class="countdown-box">
                <div class="count-number">${hours}</div>
                <div class="count-label">HOURS</div>
            </div>
            <div class="countdown-box">
                <div class="count-number">${minutes}</div>
                <div class="count-label">MINUTES</div>
            </div>
            <div class="countdown-box">
                <div class="count-number">${seconds}</div>
                <div class="count-label">SECONDS</div>
            </div>
        </div>
    </div>
`;
    }

    setInterval(updateCountdown, 1000);
});